/**
 * FNV-1a, 32-bit, as eight hex digits. Not cryptographic — it exists so an
 * episode can say WHICH map it was recorded on (a map file edited after the
 * fact would otherwise be indistinguishable), and so two runs on the same
 * bytes agree on a short id. Pure: no DOM, no Node.
 */
export function fnv1a32(s: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(16).padStart(8, "0");
}
